import { render } from "./newdatatable.vue?vue&type=template&id=4d681c31&scoped=true"
import script from "./newdatatable.vue?vue&type=script&lang=ts"
export * from "./newdatatable.vue?vue&type=script&lang=ts"

import "./newdatatable.vue?vue&type=style&index=0&id=4d681c31&lang=css"
import "./newdatatable.vue?vue&type=style&index=1&id=4d681c31&scoped=true&lang=css"
import "./newdatatable.vue?vue&type=style&index=2&id=4d681c31&lang=css"
script.render = render
script.__scopeId = "data-v-4d681c31"

export default script